/**
 * EmptyState — shared hueless empty treatment for the accountant rail cards.
 *
 * Empty ≠ bad ≠ good: neutral only, no green, no severity, no motion. The WIDTH/geometry
 * carries nothing here — it's a "nothing to show yet" marker, so it stays fully hueless.
 */

import React from 'react';
import type { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon: LucideIcon;
  label: string;
  hint?: string;
}

export default function EmptyState({ icon: Icon, label, hint }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-8 text-center">
      <Icon className="w-5 h-5" style={{ color: 'var(--color-text-dim)' }} aria-hidden="true" />
      <p className="text-[12px]" style={{ color: 'var(--color-text-muted)' }}>{label}</p>
      {hint && <p className="font-mono text-[11px]" style={{ color: 'var(--color-text-dim)' }}>{hint}</p>}
    </div>
  );
}
